module.exports = __webpack_public_path__ + "img/kyrgyzstan.ed512065.svg";